import FBtnMDP, { BtnType } from "@/components/FBtnMDP";
import FEmailFieldMDP from "@/components/form/field/FEmailFieldMDP";
import FFormMDP, { FFormChildMDP } from "@/components/form/FFormMDP";
import FTextFieldMDP from "@/components/form/field/FTextFieldMDP";
import FSelectFieldMDP from "@/components/form/field/FSelectFieldMDP";
import AddressFMiniFormMDP from "@/components/form/field/AddressFMiniFormMDP";
import FDateFieldMDP from "@/components/form/field/FDateFieldMDP";
import FNumberFieldMDP from "@/components/form/field/FNumberFieldMDP";
import FTextareaMDP from "@/components/form/field/FTextareaMDP";
import FCurrencyFieldMDP from "@/components/form/field/FCurrencyFieldMDP";
import FSelectDateFieldMDP from "@/components/form/field/FDateSelectFieldMDP";
import FAccountFieldMDP from "@/components/form/field/FAccountFieldMDP";
import FNupayBankSelectFieldMDP from "@/components/form/field/FNupayBankSelectFieldMDP";
import * as Data from "@/../src-gen/data";

export default class EMandateDetailsFFormMDP extends FFormMDP {
  childMDP = new FFormChildMDP();
  parent: any;
  constructor({ parent }: { parent: any }) {
    super({
      myRefName: "eMandateFormRef",
      readonly: true,
    });
    this.parent = parent;

    this
    .addField(
        new FTextFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "label",
          label: "Bank",
          mandatory: true,
          boundaryClass: "col-4",
        })
      )
    .addField(
      new FTextFieldMDP({
        parentMDP: this.childMDP,
        dataSelectorKey: "remoteEMandateId",
        label: "Nupay Cust Id",
        mandatory: true,
        boundaryClass: "col-4",
      })
    )
      .addField(
        new FTextFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "status.name",
          label: "Status",
          mandatory: true,
          boundaryClass: "col-4",
          
        })
      )
      .addField(
        new FCurrencyFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "amount",
          label: "Amount",
          boundaryClass: "col-4",
          mandatory: true,
        })
      )
      .addField(
        new FAccountFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "accountNumber",
          label: "Account Number",
          boundaryClass: "col-4",
          mandatory: true,
        })
      )
      .addField(
        new FTextFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "selfEnrolEMandateLink",
          label: "EMandate Link",
          mandatory: true,
          boundaryClass: "col-4",
          
        })
      )  .addField(
        new FTextFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "umrn",
          label: "UMRN",
          mandatory: true,
          boundaryClass: "col-4",
          condition: this.parent.isActive()
        })
      )  .addField(
        new FTextFieldMDP({
          parentMDP: this.childMDP,
          dataSelectorKey: "npciRefNumber",
          label: "NPCI Ref Number",
          mandatory: true,
          boundaryClass: "col-4",
          condition: this.parent.isActive()
          
        })
      )
      
      .addAction(
        new FBtnMDP({
          label: "Close",
          onClick: () => this.handleCloseClick(),
          btnType: BtnType.TEXT
        })
      )
      .addAction(
        new FBtnMDP({
          label: "Check Emandate Status",
          onClick: () => this.checkAndUpdateEMandate(),
        })
      );
      
  }
  

  getMyRef(): any {
    return this.parent.$refs[this.myRefName];
  }

  handleCloseClick() {
      this.parent.showViewEMandateForm = false;
  }
  checkAndUpdateEMandate() {
        this.parent.checkAndUpdateEMandate();
  }
}
